module.exports = __webpack_public_path__ + "img/Fintech-network-ja.f939d2d1.png";